var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8999 20C16.3182 20 19.8999 16.4183 19.8999 12C19.8999 7.58172 16.3182 4 11.8999 4C7.48162 4 3.8999 7.58172 3.8999 12C3.8999 16.4183 7.48162 20 11.8999 20ZM15.607 10.7071C15.9975 10.3166 15.9975 9.68342 15.607 9.29289C15.2165 8.90237 14.5833 8.90237 14.1928 9.29289L10.8999 12.5858L9.60701 11.2929C9.21648 10.9024 8.58332 10.9024 8.19279 11.2929C7.80227 11.6834 7.80227 12.3166 8.19279 12.7071L10.1928 14.7071C10.5833 15.0976 11.2165 15.0976 11.607 14.7071L15.607 10.7071Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStatus);
export default __webpack_public_path__ + "static/media/orangeStatus.7ec0c5c058c49e9c6addc9fcf6c59bc7.svg";
export { ForwardRef as ReactComponent };